import type { QueryClient } from '@tanstack/react-query'
import { accountingPeriodQueryKeys } from 'src/queries/organizations/accountingPeriods/accountingPeriods.queries'

export const refreshReceiptRecoveryStats = (
  queryClient: QueryClient,
  organizationId: string,
  accountingPeriodId: string,
): Promise<void> =>
  queryClient.invalidateQueries({
    exact: true,
    queryKey: accountingPeriodQueryKeys.stats(
      organizationId,
      accountingPeriodId,
    ),
  })
